import { hoverDynamic } from './hover';
import Navigo from 'navigo';

export function pushStateHandler() {
  // Navigo インスタンスの作成
  const router = new Navigo('/');
  
  // ページ遷移時のイベントを設定する関数
  function onPageTransition(handler) {
    return () => {
      handler();
      window.onpopstate = (e) => {
        router.resolve();
      };
    };
  }

  function drawerInit() {
    document.body.classList.remove('is-drawer-active');
    drawer.innerHTML = '';
  }

  // ルートハンドラ
  function routeHandler() {
    drawerInit();
  }

  // ドロワーハンドラ
  function drawerHandler() {
    document.body.classList.remove('is-nav-active', 'is-exhibitors-filter-active');
    document.body.classList.add('is-drawer-active');
    const hov = drawer.querySelectorAll('a, button, .js-hov');
    if(hov.length) {
      hov.forEach((el) => {
        hoverDynamic(el);
      })
    }
  }

  // 出展者singleページの時にハンドラを変える
  const currentLocation = router.getCurrentLocation();
  const exhibitorsSingleRegexp = new RegExp('^/exhibitors/.*$');
  let exhibitorsSingleHandler = drawerHandler;
  if (exhibitorsSingleRegexp.test(currentLocation.url)) {
    exhibitorsSingleHandler = routeHandler;
  }

  const exhibitorsEnSingleRegexp = new RegExp('^/en/exhibitors/.*$');
  let exhibitorsEnSingleHandler = drawerHandler;
  if (exhibitorsEnSingleRegexp.test(currentLocation.url)) {
    exhibitorsEnSingleHandler = routeHandler;
  }

  // フレンズsingleページの時にハンドラを変える
  const friendsSingleRegexp = new RegExp('^/friends/.*$');
  let friendsSingleHandler = drawerHandler;
  if (friendsSingleRegexp.test(currentLocation.url)) {
    friendsSingleHandler = routeHandler;
  }

  const friendsEnSingleRegexp = new RegExp('^/en/friends/.*$');
  let friendsEnSingleHandler = drawerHandler;
  if (friendsEnSingleRegexp.test(currentLocation.url)) {
    friendsEnSingleHandler = routeHandler;
  }

  // ルートの定義
  router
    .on('/', onPageTransition(routeHandler))
    .on('/en/', onPageTransition(routeHandler))

    .on('/exhibitors/', onPageTransition(routeHandler))
    .on('/exhibitors/base/*', onPageTransition(routeHandler))
    .on('/exhibitors/*', onPageTransition(exhibitorsSingleHandler))

    .on('/en/exhibitors/', onPageTransition(routeHandler))
    .on('/en/exhibitors/base/*', onPageTransition(routeHandler))
    .on('/en/exhibitors/*', onPageTransition(exhibitorsEnSingleHandler))

    .on('/friends/', onPageTransition(routeHandler))
    .on('/friends/*', onPageTransition(friendsSingleHandler))

    .on('/en/friends/', onPageTransition(routeHandler))
    .on('/en/friends/*', onPageTransition(friendsEnSingleHandler))

  const drawer = document.querySelector('.js-drawer');

  // 出展者ドロワー
  const exhibitorsPushTrigger = document.querySelectorAll('[data-exhibitors-id]');
  if(exhibitorsPushTrigger.length){
    exhibitorsPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const exhibitorsid = el.dataset.exhibitorsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(exhibitorsid && exhibitorsData) {
          const foundElement = exhibitorsData.find((element) => element['id'] == exhibitorsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const b = foundElement['booth']
            const bn = foundElement['boothnumber']
            const a = foundElement['area']
            const d = foundElement['description']
            const u = foundElement['urls']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-medium', 'font-bold', 'lh1_5');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            let attr = '';
            if(b.length || bn || a.length){
              attr = document.createElement('div');
              attr.classList.add('rowm-2');
              drawer.appendChild(attr);
            }

            if(b.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              if (document.documentElement.lang == 'en-US') {
                label.innerHTML = `Booth:`;
              } else {
                label.innerHTML = `ブース:`;
              }
              container.appendChild(label);
              const booth = document.createElement('div');
              booth.classList.add('flex', 'flex-slash');
              b.forEach((bb) => {
                const el = document.createElement('p');
                const title = bb['title'];
                if(title) {
                  el.innerHTML = `${title}`;
                }
                booth.appendChild(el);
              })
              container.appendChild(booth);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(bn){
              const el = document.createElement('p');
              el.classList.add('rowm-1');
              if (document.documentElement.lang == 'en-US') {
                el.innerHTML = `<b>Number:</b> ${bn}`;
              } else {
                el.innerHTML = `<b>番号:</b> ${bn}`;
              }
              attr.appendChild(el);
            }

            if(a.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              if (document.documentElement.lang === "en-US") {
                label.innerHTML = `Base:`;
              } else {
                label.innerHTML = `拠点:`;
              }
              container.appendChild(label);
              const area = document.createElement('div');
              area.classList.add('flex', 'flex-slash');
              a.forEach((aa) => {
                const parent = document.createElement('div');
                parent.classList.add('flex', 'flex-hyphen');
                const title = document.createElement('p');
                title.innerHTML = `${aa['title']}`;
                const childs_arr = aa['childs'];
                if(childs_arr.length) {
                  const childs = document.createElement('div');
                  childs.classList.add('flex', 'flex-comma');
                  childs_arr.forEach((c) => {
                    const el = document.createElement('p');
                    el.innerHTML = `${c['title']}`;
                    childs.appendChild(el);
                  });
                  parent.appendChild(title);
                  parent.appendChild(childs);
                } else {
                  parent.appendChild(title);
                }
                area.appendChild(parent);
              })
              container.appendChild(area);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            if(u){
              const urls = document.createElement('ul');
              urls.classList.add('pt-2', 'hover-textdecoration-underline', 'lh1_5');
              u.forEach((uu) => {
                const el = document.createElement('li');
                const _el = document.createElement('a');
                const label = uu['label'];
                const url = uu['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                urls.appendChild(el);
              })
              drawer.appendChild(urls);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  // フレンズドロワー
  const friendsPushTrigger = document.querySelectorAll('[data-friends-id]');
  if(friendsPushTrigger.length){
    friendsPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const friendsid = el.dataset.friendsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(friendsid && friendsData) {
          const foundElement = friendsData.find((element) => element['id'] == friendsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const d = foundElement['description']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-medium', 'font-bold', 'lh1_5');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  const historyBackTriggers = document.querySelectorAll('.js-history-back');
  if(historyBackTriggers.length){
    historyBackTriggers.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        history.back()
      });
    })
  }
}